import {
    CLEAR_EVENT_OPEN_BETS,
    REMOVE_NO_MORE_BETS_EVENT,
    SELECT_EVENT,
    SET_EVENT_LAST_RESULTS,
    SET_EVENTS,
    SET_MATCHDAY_UPDATE,
    SET_NEXT_EVENTS_TIMESTAMP,
    SET_NO_MORE_BETS_EVENT,
    SET_RESULT,
    SET_RESULT_COUNTER,
    SET_SELECTED_MATCHDAY_EVENT_ID,
    SET_SELECTED_MATCHDAY_SUB_EVENT_INDEX
} from '../constants/actionTypes';

export function setReceivedEvents(nextEvents, eventHasEnded = false, endedEventChannel = undefined) {
    return {type: SET_EVENTS, nextEvents, eventHasEnded, endedEventChannel};
}

export function selectEvent(eventIndex) {

    return {type: SELECT_EVENT, eventIndex};
}

export function setNextEventsTimestamp(nextEventsTimeStamp) {

    return {type: SET_NEXT_EVENTS_TIMESTAMP, nextEventsTimeStamp};
}

export function setselectedMatchdaySubEventIndex(selectedMatchdaySubEventIndex) {

    return {type: SET_SELECTED_MATCHDAY_SUB_EVENT_INDEX, selectedMatchdaySubEventIndex};
}

export function setSelectedMatchdayEventId(selectedMatchdayEventId) {

    return {type: SET_SELECTED_MATCHDAY_EVENT_ID, selectedMatchdayEventId};
}

export function setNoMoreBetsEvent(eventId, gameChannel, placeBets) {
    let nmbEvent = {
        eventId,
        gameChannel,
        creationDateTime: Date.now()
    };

    return {type: SET_NO_MORE_BETS_EVENT, nmbEvent, placeBets};
}

export function setResult(params) {
    return {type: SET_RESULT, params};
}

export function setResultCounter(channel, state, isResultShowing) {
    return {type: SET_RESULT_COUNTER, channel, state, isResultShowing};
}

export function removeNoMoreBetsEvent(channel) {
    return {type: REMOVE_NO_MORE_BETS_EVENT, channel};
}

export function clearEventOpenBets(gameChannel, eventId) {
    return {type: CLEAR_EVENT_OPEN_BETS, gameChannel, eventId};
}

export function setEventLastResults(result) {
    return {type: SET_EVENT_LAST_RESULTS, result};
}

export function setMatchdayUpdate(params) {
    return {type: SET_MATCHDAY_UPDATE, params};
}



// WEBPACK FOOTER //
// ./src/actions/eventsActions.js